import React from 'react';
import PropTypes from 'prop-types';

const PaymentTools = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='payment-tools-title'>{altText}</title>
      <path fill='currentColor' d='M8.33 3.835a.75.75 0 0 0 1.005.336c1.79-.895 3.54-.895 5.33 0a.75.75 0 1 0 .67-1.342c-2.21-1.105-4.46-1.105-6.67 0a.75.75 0 0 0-.336 1.006Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M2.25 5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0ZM5 6.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM2.25 19a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0ZM5 20.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM19 21.75a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5ZM17.75 19a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM16.25 5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0ZM19 6.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z' clipRule='evenodd'/>
      <path fill='currentColor' d='M4.17 9.335a.75.75 0 0 0-1.34-.67c-1.106 2.21-1.106 4.46 0 6.67a.75.75 0 0 0 1.34-.67c-.894-1.79-.894-3.54 0-5.33ZM20.165 8.33a.75.75 0 0 0-.336 1.005c.895 1.79.895 3.54 0 5.33a.75.75 0 0 0 1.342.67c1.105-2.21 1.105-4.46 0-6.67a.75.75 0 0 0-1.006-.336ZM9.335 19.83a.75.75 0 0 0-.67 1.34c2.21 1.106 4.46 1.106 6.67 0a.75.75 0 1 0-.67-1.34c-1.79.894-3.54.894-5.33 0ZM9 12.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H9Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M8.5 7.25A2.25 2.25 0 0 0 6.25 9.5v5a2.25 2.25 0 0 0 2.25 2.25h7a2.25 2.25 0 0 0 2.25-2.25v-5a2.25 2.25 0 0 0-2.25-2.25h-7ZM7.75 9.5v.75h8.5V9.5a.75.75 0 0 0-.75-.75h-7a.75.75 0 0 0-.75.75Zm8.5 2.25h-8.5v2.75c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75v-2.75Z' clipRule='evenodd'/>
    </svg>
  );
};

PaymentTools.propTypes = {
  altText: PropTypes.string
};

export default PaymentTools;

